import SharePointLink from './SharePointLink'
export default SharePointLink
